import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {Brands, RequestUserRegistrationDto} from "@server-models";

import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {
  SharedRegisterErrorHandlerService
} from "@shared/components/login/error-handler/shared-register-error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class TechRegisterApiService extends CoreHttpClientApiBaseService {

  requestGuestPin(email: string, brand?: Brands): Observable<void> {
    const body: RequestUserRegistrationDto = {
      email,
      brand
    }
    return super.post<void>(`/identity/userRegistration/requestUserRegistration`, false, body);
  }

  requestGuestAsUser(pin: string, email: string, passwordBase64: string): Observable<void> {
    const body: any = {
      pinFromEmail: pin,
      passwordBase64: passwordBase64,
      email
    }
    const options = {
      errorHandler: new SharedRegisterErrorHandlerService(this._store, this._alertControllerService, this._translateService, this._router)
    }
    return super.post<void>(`/identity/userRegistration/registerUser`, false, body, options);
  }

}
